(function () {
  var LOCKED_CLASS = 'returns-consent-locked';
  var ERROR_CLASS = 'returns-consent--error';

  function consentFor(form) {
    return form && form.querySelector('[data-returns-consent]');
  }

  function setError(checkbox, hasError) {
    var wrapper = checkbox.closest('[data-returns-consent-wrapper]');
    var error = wrapper.querySelector('.returns-consent__error');

    wrapper.classList.toggle(ERROR_CLASS, hasError);
    checkbox.setAttribute('aria-invalid', hasError);
    error.hidden = !hasError;
  }

  function block(checkbox) {
    setError(checkbox, true);
    checkbox
      .closest('[data-returns-consent-wrapper]')
      .scrollIntoView({ behavior: 'smooth', block: 'center' });
    checkbox.focus({ preventScroll: true });
  }

  function sync(checkbox) {
    if (checkbox.checked) setError(checkbox, false);

    // Snelle betaalknoppen (PayPal, Apple Pay) zitten in iframes en kunnen we
    // niet tegenhouden; een overlay vangt de klik af tot er een vinkje staat.
    checkbox.form.querySelectorAll('.additional-checkout-buttons').forEach(function (el) {
      el.classList.toggle(LOCKED_CLASS, !checkbox.checked);
    });
  }

  // Direct opslaan in de cart, zodat het ook meegaat bij de snelle
  // betaalknoppen (die sturen het formulier niet mee).
  function saveAttribute(checkbox) {
    var key = checkbox.name.replace(/^attributes\[(.*)\]$/, '$1');
    var attributes = {};
    attributes[key] = checkbox.checked ? checkbox.value : '';

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributes }),
    });
  }

  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-returns-consent]')) return;
    sync(e.target);
    saveAttribute(e.target);
  });

  document.addEventListener(
    'submit',
    function (e) {
      if (!e.submitter || e.submitter.name !== 'checkout') return;

      var checkbox = consentFor(e.target);
      if (!checkbox || checkbox.checked) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      block(checkbox);
    },
    true
  );

  document.addEventListener('click', function (e) {
    var locked = e.target.closest('.additional-checkout-buttons.' + LOCKED_CLASS);
    if (!locked) return;

    var checkbox = consentFor(locked.closest('form'));
    if (checkbox) block(checkbox);
  });

  function syncAll() {
    document.querySelectorAll('[data-returns-consent]').forEach(sync);
  }

  document.addEventListener('DOMContentLoaded', syncAll);
  window.addEventListener('pageshow', syncAll);
})();
